'use client';

// Client-side FAQ helpers. Both hooks derive the item count from the raw
// next-intl message tree (`useMessages()`), so a client page renders exactly
// the qN/aN keys that exist — no hardcoded count to drift from /faq.
// The full message tree is available on the client because the provider is
// mounted with all messages (see src/app/[locale]/layout.tsx).

import { useMessages, useTranslations } from 'next-intl';
import {
  buildFaqItems,
  countFaqItems,
  getFaqNamespace,
  type FaqCategory,
  type FaqItem,
} from './faq-content';

/** Number of FAQ items present in a dotted namespace (e.g. `design.contact.faq`). */
export function useFaqCount(namespace: string): number {
  const messages = useMessages();
  return countFaqItems(getFaqNamespace(messages, namespace));
}

/** Resolved FAQ items for a category, count derived from the messages. */
export function useFaqItems(category: FaqCategory): FaqItem[] {
  const t = useTranslations(category.qaNamespace);
  const count = useFaqCount(category.qaNamespace);
  return buildFaqItems(t as unknown as (key: string) => string, category, count);
}
